import { render, staticRenderFns } from "./PalletList.vue?vue&type=template&id=6342b057&scoped=true"
import script from "./PalletList.vue?vue&type=script&lang=js"
export * from "./PalletList.vue?vue&type=script&lang=js"
import style0 from "./PalletList.vue?vue&type=style&index=0&id=6342b057&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6342b057",
  null
  
)

export default component.exports